import { render, staticRenderFns } from "./DownloadFile.vue?vue&type=template&id=0e27c652"
import script from "./DownloadFile.vue?vue&type=script&lang=js"
export * from "./DownloadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports